import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { menuItems } from '../data/mock';
import { Card } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const Menu = () => {
  const { language, t } = useLanguage();

  const MenuItem = ({ item, showImage = false }) => (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow duration-300">
      {showImage && item.image && (
        // <div className="h-48 overflow-hidden">
        <div className="h-72 overflow-hidden">
          <img
            src={item.image}
            alt={language === 'ro' ? item.name : item.nameEn}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="p-5">
        <div className="flex justify-between items-start mb-2">
          <h3 className="font-semibold text-lg" style={{ color: 'var(--brown-dark)' }}>
            {language === 'ro' ? item.name : (item.nameEn || item.name)}
          </h3>
          <span className="font-bold text-lg whitespace-nowrap ml-3" style={{ color: 'var(--amber)' }}>
            {item.price}
          </span>
        </div>
        {item.description && (
          <p className="text-sm" style={{ color: 'var(--brown-medium)' }}>
            {language === 'ro' ? item.description : (item.descriptionEn || item.description)}
          </p>
        )}
      </div>
    </Card>
  );

  return (
    <section id="menu" className="py-20" style={{ backgroundColor: 'var(--cream)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="mb-3">{t.menu.title}</h2>
          <p className="text-lg" style={{ color: 'var(--brown-medium)' }}>
            {t.menu.subtitle}
          </p>
        </div>

        <Tabs defaultValue="beer" className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4 mb-8 bg-white shadow-sm">
            <TabsTrigger value="beer" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.menu.beerDraft}
            </TabsTrigger>
            <TabsTrigger value="drinks" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.menu.drinks}
            </TabsTrigger>
            <TabsTrigger value="snacks" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.menu.snacks}
            </TabsTrigger>
            <TabsTrigger value="hookah" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.menu.hookah}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="beer" className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {menuItems.beerDraft.map((item) => (
                <MenuItem key={item.id} item={item} showImage={true} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="drinks" className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {menuItems.drinks.map((item) => (
                <MenuItem key={item.id} item={item} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="snacks" className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {menuItems.snacks.map((item) => (
                <MenuItem key={item.id} item={item} showImage={true} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="hookah" className="animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {menuItems.hookah.map((item) => (
                <MenuItem key={item.id} item={item} />
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Menu;